<template>
  <BaseModal :value="true" @input="$emit('close')">
    <div class="flex flex-col justify-center items-center">
      <h1 class="text-center">
        {{ $t("message.product_images.copy_from_product") }}
      </h1>
      <input
        type="text"
        class="regular bordered center-text w-60 mt-6"
        @input="search()"
        v-model="searchText"
      />
      <div v-if="!loading" id="images" class="flex flex-row flex-wrap mt-20">
        <div
          v-for="image in images"
          :style="{ backgroundImage: 'url(' + image.imageRoute + ')' }"
          :key="image.id"
          class="
          w-40 h-40 bg-cover border border-gray-300 rounded-md mx-1
          flex justify-center items-end
          "
        >
          <button class="btn-dark-button mb-2" @click="copyImage(image.id)">
            {{ $t("message.product_images.copy") }}
          </button>
        </div>
      </div>
      <div v-else>
        <BaseLoading></BaseLoading>
      </div>
    </div>
  </BaseModal>
</template>
<script>
import { getProductImages } from "@/api/store/ProductsService.js";
import { copyImageFamily } from "@/api/masterAdmin/ProductImagesService.js";

export default {
  name: "ProductImageCopier",
  props: {
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      images: [],
      searchText: "",
      loading: false
    };
  },
  methods: {
    search() {
      getProductImages(this.searchText)
        .then(res => {
          this.images = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    copyImage(id) {
      copyImageFamily(this.code, id)
        .then(res => {
          this.$toast.open({
            message: `${res.message}`,
            type: "success",
            position: "top-right"
          });
          this.$emit("imageCopied");
        })
        .catch(err => {
          this.$toast.open({
            message: `${err.response.data.message}`,
            type: "error",
            position: "top-right"
          });
        });
    }
  }
};
</script>
